jQuery(document).ready(function ($) {
    $(window).load(function() { 

        /**
         * Conta o número de cliques em botões de compartilhar um post patrocinado no topo da página
         */

        $('.jc-posts .jc-post-social-media-share a').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Topo',
            'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
            'eventLabel': $('.jc-post-title').text()
            });

            gtag('event', 'LP - Post - Topo', {
                'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
                'eventLabel': $('.jc-post-title').text()
            });
        });

        /**
         * Conta o número de cliques nos botões de midia social no rodape da página
         */

        $(".jc-footer .jc-socia-media-list-item a").click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Rodapé',
            'eventAction': 'Cliques',
            'eventLabel': $(this).data('social-type')
            });

            
            gtag('event', 'LP - Post - Rodapé', {
                'eventAction': 'Cliques',
                'eventLabel': $(this).data('social-type')
            });
        });

        /**
         * Conta o número de cliques em botões de envio de lead no modal em uma LP
         */

        $(".jc-bottom-form-bar-body form input[type='submit']").click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Formulário - Modal',
            'eventAction': 'Cliques',
            'eventLabel': $(this).val()
            });

            gtag('event', 'LP - Post - Formulário - Modal', {
                'eventAction': 'Cliques',
                'eventLabel': $(this).val()
            });
        });

        /**
         * Conta o número de cliques em botões de envio de lead em uma LP
         */

        $("form input[type='submit']:not(.jc-bottom-form-bar-body form input[type='submit'])").click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Formulário',
            'eventAction': 'Cliques',
            'eventLabel': $(this).val()
            });

            gtag('event', 'LP - Post - Formulário', {
                'eventAction': 'Cliques',
                'eventLabel': $(this).val()
            });
        });

        /**
         * Conta o número de cliques no botão voltar
         */

        $(".jc-post-breadcrumb a").click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Topo',
            'eventAction': 'Clique',
            'eventLabel': $(this).text()
            });

            gtag('event', 'LP - Post - Topo', {
                'eventAction': 'Clique',
                'eventLabel': $(this).text()
            });
        });

        /**
         * Conta o número de cliques no card de um post patrocinado
         */

        $('.jc-post-thumb').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Relacionados',
            'eventAction': 'Cliques',
            'eventLabel': $(this).find('.jc-post-thumb-title').text()
            });

            gtag('event', 'LP - Post - Relacionados', {
                'eventAction': 'Cliques',
                'eventLabel': $(this).find('.jc-post-thumb-title').text()
            });
        });

        /**
         * Conta o número de cliques na logo do post
         */

        $('.navbar .navbar-brand').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Topo',
            'eventAction': 'Cliques - Logo',
            'eventLabel': $(".navbar .navbar-brand").attr('href'), 
            });
        });

        gtag('event', 'LP - Post - Topo', {
            'eventAction': 'Cliques - Logo',
            'eventLabel': $(".navbar .navbar-brand").attr('href'), 
        });

        /**
         * Conta o número de cliques nas mídias de post relacionados
         */

        $('.jc-post-thumb-header a').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Relacionados',
            'eventAction': 'Compartilhar - ' + $(this).data('social-type'),
            'eventLabel': $(".jc-post-thumb").find('.jc-post-thumb-title').text(),
            });
        });

        gtag('event', 'LP - Post - Relacionados', {
            'eventAction': 'Compartilhar - ' + $(this).data('social-type'),
            'eventLabel': $(".jc-post-thumb").find('.jc-post-thumb-title').text(),
        });

        /**
         * Conta o número de cliques nos botões de midia social ao fim do conteudo do post
         */
        $('.jc-lp-custom-font:not(.jc-posts) .jc-post-social-media-share a').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Rodapé',
            'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
            'eventLabel': $('.jc-post-title').text(),
            });
        });

        gtag('event', 'LP - Post - Rodapé', {
            'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
            'eventLabel': $('.jc-post-title').text(),
        });

        /**
         * Monitora os clicks em links dentro do conteudo do post
         */
        $('.post-patrocinado-content a').click(function(){
            dataLayer.push({
            'event': 'eventGA',
            'eventCategory': 'LP - Post - Conteúdo',
            'eventAction': 'Cliques - Links',
            'eventLabel': $(this).text(),
            });
        });

        gtag('event', 'LP - Post - Conteúdo', {
            'eventAction': 'Cliques - Links',
            'eventLabel': $(this).text(),
        });

    });
});

/**
 * Atribui os valores do evento de clique nos cliques dos botoes de cta no modal de um formulario de Post
* Função chamada na main.js
*/
function clickEventModalFormPostLandingPage(text){
    dataLayer.push({
    'event': 'eventGA',
    'eventCategory': 'LP - Post - Formulario - Modal',
    'eventAction': 'Cliques',
    'eventLabel': text,
    });

    gtag('event', 'LP - Post - Formulario - Modal', {
        'eventAction': 'Cliques',
        'eventLabel': text,
    });
}